/* eslint-disable @typescript-eslint/naming-convention */

import { styled } from '@mui/material/styles';
import { Drawer } from '@mui/material';
import { drawer } from '../../const/componentSize';

// サイドメニューのスタイル
export const StyledDrawerHeader = styled('div')(() => ({
	display: 'flex',
	justifyContent: 'flex-end',
}));

export const StyledDrawer = styled(Drawer)(() => ({
	flexShrink: 0,
	'& .MuiDrawer-paper': {
		width: drawer.width,
		boxSizing: 'border-box',
	},
}));
